import { useMutation } from "@tanstack/react-query";
import request from "../../../Api/Api.js";
import { useToast } from "../../Ui/use-toast";

function getToken() {
  if (localStorage.getItem("user") != null) {
    return JSON.parse(localStorage.getItem("user")).accessToken;
  } else {
    return "";
  }
}

export function useUpdateSavedQuery() {
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({ queryId, updatedQuery }) =>
      request.patch(`/savedQueries/${queryId}`, updatedQuery, {
        headers: { Authorization: `Bearer ${getToken()}` },
      }),
    onSuccess: () => {
      toast({
        variant: "success",
        title: "Success!",
        description: "Query updated successfully!",
      });
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: `Failed to update query: ${
          error?.message || "An error occurred"
        }`,
        variant: "destructive",
      });
    },
  });
}
